import * as actions from './metaConfig.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ExtMetaConfigModel } from '@smarttask-common/src/lib/models/Integrations/Meta/Config/ExtMetaConfigModel';

export const configAdapter = createEntityAdapter<ExtMetaConfigModel>({
    selectId: (x) => x.config_id,
});
export interface MetaConfigState extends EntityState<ExtMetaConfigModel> {
    selected_config_id: number;
}

export const initialState: MetaConfigState = configAdapter.getInitialState({
    selected_config_id: undefined,
});

export function MetaConfigReducers(state: MetaConfigState = initialState, action: actions.MetaConfigActions) {
    switch (action.type) {
        case actions.MetaConfigActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_config_id: action.selected_config_id };
            return state;

        case actions.MetaConfigActionTypes.ADD_META_CONFIG:
            return configAdapter.addOne(action.config, state);

        case actions.MetaConfigActionTypes.ADD_META_CONFIGS:
            return configAdapter.addMany(action.configs, state);

        case actions.MetaConfigActionTypes.UPSERT_META_CONFIG:
            return configAdapter.upsertOne(action.config, state);

        case actions.MetaConfigActionTypes.UPSERT_META_CONFIGS:
            return configAdapter.upsertMany(action.configs, state);

        case actions.MetaConfigActionTypes.UPDATE_META_CONFIG:
            return configAdapter.updateOne(action.config, state);

        case actions.MetaConfigActionTypes.UPDATE_META_CONFIGS:
            return configAdapter.updateMany(action.configs, state);

        case actions.MetaConfigActionTypes.DELETE_META_CONFIG:
            return configAdapter.removeOne(action.config_id, state);

        case actions.MetaConfigActionTypes.DELETE_META_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.MetaConfigActionTypes.DELETE_ALL_META_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.MetaConfigActionTypes.DELETE_ALL:
            return configAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getMetaConfigState = createFeatureSelector<MetaConfigState>('metaConfig');

export const { selectIds, selectEntities, selectAll, selectTotal } = configAdapter.getSelectors(getMetaConfigState);

const getSelectedConfigIdState = (state: MetaConfigState) => {
    return state.selected_config_id;
};
export const getSelectedConfigId = createSelector(getMetaConfigState, getSelectedConfigIdState);

export const getSelectedConfig = createSelector(getMetaConfigState, (state: MetaConfigState) => {
    if (state.selected_config_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_config_id];
});
